<template>
  <div class="detail_page">
    <div class="top_container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        信息录入
      </div>

      <div class="button_list flex-right">
        <el-button size="mini" type="primary" @click="back">返回列表</el-button>
      </div>
    </div>
    <el-tabs class="tabs_container" v-model="pageIndex">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <!-- 市场信息 -->
    <market-info-tab
      ref="marketInfoTab"
      v-show="pageIndex === 'marketInfoTab'"
    />
    <!-- 历史销量导入 -->
    <history-sale-import-tab
      ref="historySaleImportTab"
      v-show="pageIndex === 'historySaleImportTab'"
    />
    <!-- 行业信息 -->
    <industry-info-tab
      ref="industryInfoTab"
      v-show="pageIndex === 'industryInfoTab'"
    />
    <!-- 竞争信息 -->
    <compete-info-tab
      ref="competeInfoTab"
      v-show="pageIndex === 'competeInfoTab'"
    />
    <!-- 渠道信息 -->
    <channel-info-tab
      ref="channelInfoTab"
      v-show="pageIndex === 'channelInfoTab'"
    />
  </div>
</template>

<script>
import MarketInfoTab from "./components/marketInfoTab/index.vue";
import HistorySaleImportTab from "./components/historySaleImportTab/index.vue";
import IndustryInfoTab from "./components/industryInfoTab/index.vue";
import CompeteInfoTab from "./components/competeInfoTab/index.vue";
import ChannelInfoTab from "./components/channelInfoTab/index.vue";

export default {
  components: {
    MarketInfoTab,
    HistorySaleImportTab,
    IndustryInfoTab,
    CompeteInfoTab,
    ChannelInfoTab
  },
  data() {
    return {
      tabList: [
        { label: "市场信息", name: "marketInfoTab" },
        { label: "历史销量导入", name: "historySaleImportTab" },
        { label: "行业信息", name: "industryInfoTab" },
        { label: "竞争信息", name: "competeInfoTab" },
        { label: "渠道信息", name: "channelInfoTab" }
      ],
      pageIndex: "marketInfoTab" // 当前显示tab索引
    };
  },

  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.top_container {
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: #fff;
  padding: 15px 32px 15px 14px;
  border-bottom: 5px solid #efefef;
  .split {
    margin: 0 10px 0 7px;
    border: 1px solid #dde0e8;
    height: 18px;
  }
}
.tabs_container {
  padding-top: 15px;
  ::v-deep {
    .el-tabs__item {
      font-size: 16px;
      height: 34px;
      line-height: 32px;
    }
    .el-tabs__nav-wrap {
      padding: 0 40px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }
}
</style>
